import { EmployeeIdentificationType } from '@fora-monorepo/employer-my-pages-common/types';
import { Assets, Container, Flex, Headings, Text } from '@foradevelopment/fora-ui';

import { formatEmployeeId, getEmployeeIdTypeString } from '../../common/utils';
import { useTypedTranslation } from '../../i18n/i18n';

export const PersonDetails = ({
  firstName,
  lastName,
  identificationType,
  employeeId,
  headingSize = 'H3',
  policyNumber,
  isVerified,
}: {
  firstName: string;
  lastName: string;
  identificationType: EmployeeIdentificationType;
  employeeId: string;
  headingSize?: 'H3' | 'H4';
  policyNumber?: string;
  isVerified?: boolean;
}) => {
  const { t } = useTypedTranslation();
  return (
    <Container>
      {headingSize === 'H4' ? (
        <Headings.H4 color="black90" marginBottom={10}>
          {firstName} {lastName}
        </Headings.H4>
      ) : (
        <Headings.H3 color="black90" marginBottom={10}>
          {firstName} {lastName}
        </Headings.H3>
      )}
      <Text size="small" color="black70">
        {getEmployeeIdTypeString(identificationType)}
      </Text>
      <Flex columnGap={20} flexDirection={['column', 'row']}>
        <Text size="medium" color="black90">
          {formatEmployeeId(employeeId)}
        </Text>
        {policyNumber &&
          ((identificationType === EmployeeIdentificationType.CoOrdinationNumber && isVerified) ||
            identificationType === EmployeeIdentificationType.PersonalIdentityNumber) && (
            <Flex columnGap={6} alignItems="center">
              <Assets.CircleInfoIcon color="black70" />
              <Text color="black70">{t('section.employeeDetails.detailsAutoFetched')}</Text>
            </Flex>
          )}
      </Flex>
    </Container>
  );
};
